import { useId, useRef, type CSSProperties, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '../Typography/Typography';
import '../Dialog/Dialog.css';
import './Sheet.css';

/** A non-modal sheet below an accessible page header, sharing the modal sheet surface. */
export function DockedSheet({ top, title, onExpand, children, animateEntrance = false }: {
  animateEntrance?: boolean; top: number; title: string; onExpand: () => void; children: ReactNode;
}) {
  const { t } = useTranslation();
  const id = useId();
  const gesture = useRef({ y: 0, dragged: false });
  return <section className="dialog dialog--sheet docked-sheet" aria-labelledby={id}
    data-testid="participants-docked-sheet" data-animate-entry={animateEntrance || undefined}
    style={{ '--sheet-viewport': '100dvh', '--sheet-height': `calc(100dvh - ${top}px)` } as CSSProperties}>
    <div className="dialog__card">
      <button type="button" className="sheet__handle" aria-label={t('sheet.expand')}
        onPointerDown={event => { gesture.current = { y: event.clientY, dragged: false }; event.currentTarget.setPointerCapture(event.pointerId); }}
        onPointerUp={event => { if (gesture.current.y - event.clientY > 24) { gesture.current.dragged = true; onExpand(); } }}
        onClick={() => { if (!gesture.current.dragged) onExpand(); gesture.current.dragged = false; }}
        onKeyDown={event => { if (event.key === 'ArrowUp') { event.preventDefault(); onExpand(); } }}><span /></button>
      <div className="dialog__header"><Typography as="h2" role="title/card" className="dialog__title" id={id}>{title}</Typography></div>
      <div className="dialog__body">{children}</div>
    </div>
  </section>;
}
